import { render, staticRenderFns } from "./certificadoView.vue?vue&type=template&id=634a7b36&"
import script from "./certificadoView.vue?vue&type=script&lang=js&"
export * from "./certificadoView.vue?vue&type=script&lang=js&"
import style0 from "./certificadoView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports